import { mapMutations } from 'vuex'

export default {
  props: {
    giftData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    isLogin() {
      return Object.keys(this.user).length > 0
    },
    isReserved() {
      return this.$store.getters.isReserved
    },
    query() {
      return this.$route.query
    },
  },
  created() {
    if (this.query.inviteCode) this.openReserveDialogFromUrl()
  },
  methods: {
    ...mapMutations(['setTipsDialog']),
    openReserveDialog() {
      if (this.isLogin && this.isReserved) {
        this.setTipsDialog({ visible: true, tips: '领取成功，请在游戏正式上线后，在本官网下载并登录创角即可领取对应奖励。' })
        return
      }
      this.$emit('reserve')
    },
    openReserveDialogFromUrl() {
      if (this.isLogin && this.isReserved) return false
      
      this.$emit('reserve')
    },
    openRuleDialog() {
      this.$emit('viewRule', this.giftData.rule)
    },
    getGiftImg(name) {
      return require('@/assets/img/common/gift/' + name)
    },
  }
}